import svgSteam from '@/pages/intelligence/assets/svg/dataSource/steam.svg';

const TOOLTIP_IMAGE_STYLE_ID = 'dbi-chart-bubble-tooltip-image-style';
const tooltipImageClassCache = new Map<string, string>();
const tooltipImageStyleCache = new Set<string>();

const escapeTooltipAttr = (value: unknown) => {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
};

const escapeTooltipCssUrl = (value: string) => {
  return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '');
};

const injectTooltipImageStyle = (className: string, imageSrc: string) => {
  if (typeof document === 'undefined' || tooltipImageStyleCache.has(className)) {
    return;
  }

  let styleElement = document.getElementById(TOOLTIP_IMAGE_STYLE_ID);
  if (!styleElement) {
    styleElement = document.createElement('style');
    styleElement.id = TOOLTIP_IMAGE_STYLE_ID;
    document.head.appendChild(styleElement);
  }
  styleElement.appendChild(
    document.createTextNode(`.${className}{background-image:url("${escapeTooltipCssUrl(imageSrc)}");}\n`),
  );
  tooltipImageStyleCache.add(className);
};

const getTooltipImageClassName = (src: unknown) => {
  const imageSrc = String(src || '');
  if (!imageSrc) {
    return '';
  }

  const cachedClassName = tooltipImageClassCache.get(imageSrc);
  if (cachedClassName) {
    injectTooltipImageStyle(cachedClassName, imageSrc);
    return cachedClassName;
  }

  const className = `dbi-chart-bubble-bg-img-${tooltipImageClassCache.size + 1}`;
  tooltipImageClassCache.set(imageSrc, className);
  injectTooltipImageStyle(className, imageSrc);

  return className;
};

export const renderTooltipImage = (src: unknown, className = '') => {
  const imageClassName = getTooltipImageClassName(src);
  if (!imageClassName) {
    return '';
  }
  const steamModifier = String(src || '').includes(svgSteam) ? ' bubble-lf-img--steam' : '';

  return `<span class="${escapeTooltipAttr(
    `${className} dbi-chart-bubble-bg-img ${imageClassName}${steamModifier}`,
  )}" aria-hidden="true"></span>`;
};
